export default __webpack_public_path__ + "static/media/delete-outline.5e24845b.svg";